import profile1 from '../Assets/img/profile-1.png';
import profile2 from '../Assets/img/profile-2.png';
import profile3 from '../Assets/img/profile-3.png';
import profile4 from '../Assets/img/profile-4.png';

const TestimonialData = [
    {
        id:1,
        profileimg:profile1,
        comment:'I use OKC Uptown Cleaning to help keep my mother’s home clean. They are always on time. Only once we they delayed, but they let me know when to expect them. They are very professional and very friendly. They always to a great job. They charge a fair price. I would highly recommend them.',
        name:'David Key'
    },

    {
        id:2,
        profileimg:profile2,
        comment:'I work for Jaynee at Uptown Cleaning and I absolutely love her and her methods for ensuring the cleanliness as well as happiness of our clients. She is a delight to work for. Great communicator and all around amazing person to work for!! She gives you all the tools you need to succeed at your job.',
        name:'Sandra Ham'
    },

    {
        id:3,
        profileimg:profile3,
        comment:'Jaynee and her team at OKC Uptown Cleaning Services are wonderful to work with! They are professional, thorough, timely, responsive, flexible, and great communicators!  They clean my AirBNB and I couldn’t be happier with their work.  I couldn’t make my small business work without them.   They are the best!  Highly recommend them. Crystal Johnson',
        name:'Crystal Johnson'
    },

    {
        id:4,
        profileimg:profile4,
        comment:'Uptown Cleaning Services has been a godsend!  Jaynee and her team are passionate about what they do and the level of service they provide.  They are very detailed.  And they are very dog-friendly which was a must for my house!  Grateful to have been referred to them!',
        name:'Shannon Hayes'
    }

]

export default TestimonialData;